import { connect } from "react-redux";
import CustomerItemsProductTile from "../../../presentational/customerItems/ProductTile";
import {
  isDeletingOrDeleted,
  isToBagInProgressOrComplete
} from "../../../../state/modules/savedItems/selectors/itemStateSelectors";

const mapStateToProps = (_, { itemState }) => ({
  isDeletingOrDeleted: isDeletingOrDeleted({ itemState }),
  isToBagInProgressOrComplete: isToBagInProgressOrComplete({ itemState })
});

export default connect(mapStateToProps)(CustomerItemsProductTile);
